import { render, staticRenderFns } from "./BuyBtn.vue?vue&type=template&id=549f0ec6&scoped=true&"
import script from "./BuyBtn.vue?vue&type=script&lang=js&"
export * from "./BuyBtn.vue?vue&type=script&lang=js&"
import style0 from "./BuyBtn.vue?vue&type=style&index=0&id=549f0ec6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549f0ec6",
  null
  
)

export default component.exports